module.exports = __webpack_public_path__ + "static/colgadas-004-96f3fc81e908e3286af970acfdb2d448.jpg";